import React from "react";
import "./App.css";
import LoginForm from "./auth/LoginForm";
import SignUpForm from "./auth/SignUpForm";
import WorkoutForm from "./workouts/WorkoutForm";
import Workouts from "./workouts/Workouts";
import NavBar from "./navbars/NavBar";
import { useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import { Route, Routes } from "react-router-dom";
import Home from "./Home";
import WorkoutApi from "./Api";
import ExerciseForm from "./exercises/ExerciseForm";
import WorkoutEditForm from "./workouts/WorkoutEditForm";
import UserEditForm from "./auth/UserEditForm";
import WorkoutPage from "./workouts/WorkoutPage";
import SetForm from "./sets/SetsForm";
import SetTable from "./sets/SetTable";
import ExerciseEditForm from "./exercises/ExerciseEditForm";
import NotFound from "./NotFound";

export const TOKEN_STORAGE_ID = "jobly-token";

function App() {
 
  const [currentToken, setToken] = useState(window.localStorage.getItem("token"));
  const [currentUser, setUser] = useState("");
  useEffect(() => {
    async function getCurrentUser() {
      if (currentToken) {
        try {
          //* Store the token in the API Function
          WorkoutApi.token = currentToken;
          console.log(WorkoutApi.token);
          //* Use react-jwt instead of jwttoken because it'll work on the frontend then decode the token to get the user
          let { username } = decodeToken(currentToken);
          let usersItem = await WorkoutApi.getUserName(username);
          window.localStorage.setItem("user", JSON.stringify(usersItem));
          setUser(usersItem);
        } catch (error) {
          console.log("no token");
        }
      }
    }
    getCurrentUser();
    // const newUser = JSON.parse(localStorage.getItem("user")) || null;
    console.log("look", currentToken);
    // console.log("newUser", currentUser);
  }, [currentToken]);

  async function login(loginData) {
    try {
      let res = await WorkoutApi.authenticateUsers(loginData);
      console.log(res.token);
      setToken(window.localStorage.setItem("token", res.token));
      return { success: true };
    } catch (errors) {
      console.log([errors.message]);
      console.error("login failed", errors);
      return { success: false, errors };
    }
  }

  // async function signup(signupData) {
  //   try {
  //     let token = await WorkoutApi.registerUsers(signupData);
  //     setToken(token);
  //     return { success: true };
  //   } catch (errors) {
  //     console.error("signup failed", errors);
  //     return { success: false, errors };
  //   }
  // }

  return (
    <div className="App">
      <NavBar
        token={currentToken}
        username={currentUser ? currentUser.username : ""}
      />
           <Routes>
        <Route 
          path="/" 
          element={<Home token={currentToken} name={currentUser ? currentUser.firstName : ""} />} 
        />
        <Route 
          path="/login" 
          element={<LoginForm login={login} />} 
        />
        <Route 
          path="/signup" 
          element={<SignUpForm />} 
        />
        <Route 
          path="/users/profile" 
          element={<UserEditForm token={currentToken} />} 
        />
        <Route 
          path="/workouts" 
          element={<Workouts token={currentToken} />} 
        />
        <Route 
          path="/workouts/create" 
          element={<WorkoutForm token={currentToken} />} 
        />
        <Route 
          path="/workouts/:id" 
          element={<WorkoutPage token={currentToken} />} 
        />
        <Route 
          path="/workouts/:id/edit" 
          element={<WorkoutEditForm token={currentToken} />} 
        />
        <Route 
          path="/exercise/:workout_id/create" 
          element={<ExerciseForm token={currentToken} />} 
        />
        <Route 
          path="/exercise/:exercise_id/edit" 
          element={<ExerciseEditForm token={currentToken} />} 
        />
        <Route 
          path="/exercise/set" 
          element={<SetForm token={currentToken} />} 
        />
        <Route 
          path="/set/:exercise_id" 
          element={<SetTable token={currentToken} />} 
        />
        <Route 
          path="*" 
          element={<NotFound />} 
        />
      </Routes>
    </div>
  );
}

export default App;
